// extracted by mini-css-extract-plugin
export var root = "index-module--root--1dda9";